import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/system';
import { QuickFiltersButton } from './QuickFiltersButton.js';

function QuickFilters({ filters, activeFilterId, setActiveFilterId }) {
    return (jsx(QuickFiltersWrapper, { children: filters.map(({ id, title, onClick, "data-testid": dataTestId }) => (jsx(QuickFiltersButton, { "aria-selected": activeFilterId === id, "data-testid": dataTestId, id: id, onClick: () => {
                setActiveFilterId(id);
                onClick();
            }, children: title }, id))) }));
}
const QuickFiltersWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(2, 4),
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "stretch",
    gap: theme.spacing(1.25),
    alignSelf: "stretch",
    borderRight: `1px solid ${theme.palette.ui50}`,
}));

export { QuickFilters };
//# sourceMappingURL=QuickFilters.js.map
